import { BasicInfo, Category, Service } from "@/types"
import { CategoryMenu } from "./category/category-menu"

type PropsImageMenu = {
  basicInfo: BasicInfo
  categories: Category[]
  itemNames: Record<string, string> | undefined
  deliveryService: Service
}

export function ImageMenu({ basicInfo, categories, itemNames, deliveryService }: PropsImageMenu) {
  return (
    <>
      <CategoryMenu
        basicInfo={basicInfo}
        categories={categories}
        itemNames={itemNames}
        deliveryService={deliveryService}
      />
    </>
  )
}